import { UserClaimTypes, UserManager } from "app/core";
import { UniversalAppShell } from "component-library";
import React, { PropsWithChildren, useEffect } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";
import { useSupportChat } from "shared-hooks";
import { FEATURE_FLAGS, useLaunchDarklyFlags } from "shared-services";
import { GlobalEventTypes } from "contexts/GlobalContext";
import ProfileMiniFooter from "components/common/ProfileFooter";
import { CommonSection } from "sections/CommonSection";
import { config } from "config";
import {
  IGlobalContextProps,
  withGlobalContext,
} from "shared/contexts/GlobalContext";
import compose from "shared/utils/compose";
import withPathsFilmmakersAccessRestriction from "app/hoc/withPathsFilmmakersAccessRestriction";
import { MEDIA_ADD_FULL_PATH, VIEW_PIN_PATTERN } from "app/config/routes";

const MasterPage = ({
  globalContext,
}: PropsWithChildren<IGlobalContextProps>) => {
  const isProfileRedesignEnabled = useLaunchDarklyFlags(
    FEATURE_FLAGS.ProfileRedesign
  );

  const location = useLocation();

  useSupportChat(location.pathname, undefined, config.supportChatBotId);

  useEffect(() => {
    globalContext.notifyListener(
      GlobalEventTypes.makeVisibleGlobalSpinner,
      false
    );

    return () => {
      UserManager.setClaim(UserClaimTypes.userId, "");
    };
  }, []);

  const isPublicProfilePage = VIEW_PIN_PATTERN.test(location.pathname);
  const isAddMediaPage = Boolean(
    matchPath({ path: MEDIA_ADD_FULL_PATH, end: true }, location.pathname)
  );

  return (
    <UniversalAppShell
      footerComponent={isPublicProfilePage && <ProfileMiniFooter />}
      hideFooter={isProfileRedesignEnabled && !isAddMediaPage}
    >
      <div id="content-container">
        <div className="a-master-page__hidden-panel" />
        <Outlet />
      </div>
      <CommonSection />
    </UniversalAppShell>
  );
};

export default compose(
  withGlobalContext,
  withPathsFilmmakersAccessRestriction([
    "/profile/linktoprofile",
    "/profile/myviewpin",
  ])
)(MasterPage);
